export const replaceFloatValue = (number) => {
  if (number == NaN) {
    return 0;
  }
  if (Number.isInteger(number)) {
    return number;
  } else {
    const fixedNum = number?.toFixed(2);

    return fixedNum;
  }
};
